var $f65392426e2dae6a$exports = {};
$f65392426e2dae6a$exports = {
    "dismiss": `Lukk`
};


export {$f65392426e2dae6a$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
